var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 19.5C4.875 11.4228 11.4228 4.875 19.5 4.875C27.5772 4.875 34.125 11.4228 34.125 19.5C34.125 27.5772 27.5772 34.125 19.5 34.125C11.4228 34.125 4.875 27.5772 4.875 19.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1201 16.25C26.1201 19.8399 23.0899 22.75 19.5 22.75C15.9101 22.75 13 19.8399 13 16.25C13 12.6601 15.9101 9.75 19.5 9.75C23.0899 9.75 26.1201 12.6601 26.1201 16.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5006 24.375C23.948 24.3751 27.7984 26.5633 29.6686 29.7517C29.7256 29.8488 29.7079 29.9719 29.6267 30.0499C26.9988 32.573 23.4313 34.1249 19.5006 34.125C15.5696 34.125 12.0015 32.5732 9.37351 30.0499C9.29232 29.9719 9.27463 29.8488 9.33157 29.7517C11.2018 26.5631 15.053 24.375 19.5006 24.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/Profile_icon.74c34fffccd2a981f156f538fa175003.svg";
export { ForwardRef as ReactComponent };